var _style, _polygon, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 648 648",
    style: {
      enableBackground: "new 0 0 648 648"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FF4136;}\r\n")), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    id: "arrow",
    className: "st0",
    points: "463,185 181.6,188.1 181.3,216.8 414.9,214.2 175.5,453.6 195.6,473.7 433.7,235.6  431.2,466.7 459.9,466.4 "
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "circle"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M322.9,26.6c40.3,0,79.4,7.9,116.2,23.4c35.5,15,67.5,36.6,94.9,64c27.4,27.4,48.9,59.3,64,94.9 c15.6,36.8,23.4,75.9,23.4,116.2s-7.9,79.4-23.4,116.2c-15,35.5-36.6,67.5-64,94.9c-27.4,27.4-59.3,48.9-94.9,64 c-36.8,15.6-75.9,23.4-116.2,23.4s-79.4-7.9-116.2-23.4c-35.5-15-67.5-36.6-94.9-64c-27.4-27.4-48.9-59.3-64-94.9 c-15.6-36.8-23.4-75.9-23.4-116.2s7.9-79.4,23.4-116.2c15-35.5,36.6-67.5,64-94.9c27.4-27.4,59.3-48.9,94.9-64 C243.5,34.5,282.6,26.6,322.9,26.6 M322.9,0.6C143.7,0.6-1.6,145.9-1.6,325.1s145.3,324.4,324.4,324.4s324.4-145.3,324.4-324.4 S502.1,0.6,322.9,0.6L322.9,0.6z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right-arrow.09b8ba510ff54f9bf3f4c4f827d02f6d.svg";
export { ForwardRef as ReactComponent };